const getParamValue = (param) => {
    const queryString = window.location.search || '';
    const paramRegex = new RegExp(`${param}=([^&]*)`);
    const matches = queryString.match(paramRegex) || [];
    return matches.length > 1 ? matches[1] : null;
};
export { getParamValue };
